import { render, staticRenderFns } from "./MicroBase.vue?vue&type=template&id=45a28712&scoped=true"
import script from "./MicroBase.vue?vue&type=script&lang=js"
export * from "./MicroBase.vue?vue&type=script&lang=js"
import style0 from "./MicroBase.vue?vue&type=style&index=0&id=45a28712&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a28712",
  null
  
)

export default component.exports